import * as S from './VisuallyHidden.styles';
const VisuallyHidden = ({ children }) => {
  return <S.Container>{children}</S.Container>;
};

export default VisuallyHidden;
